import { RouterProvider } from 'react-router-dom'
import { router } from './Router'
import { MaintenanceWatcher } from './shared/components/MaintenanceWatcher'

export const App = () => {
  return (
    <>
      <MaintenanceWatcher />
      <RouterProvider router={router} />
    </>
  )
}
